import { useEffect } from "react";
import { onLCP, onINP, onCLS, onFCP, onTTFB } from "web-vitals";

const APPPULSE_URL = process.env.REACT_APP_APPPULSE_URL;
const APPPULSE_KEY = process.env.REACT_APP_APPPULSE_KEY;

// Strip auth tokens from URLs before sending to analytics
// Supabase/OAuth put JWTs in hash fragments (e.g. #access_token=eyJ...)
function sanitizeUrl(href) {
  try {
    const url = new URL(href);
    if (url.hash && /access_token|token|code=/.test(url.hash)) {
      url.hash = "";
    }
    return url.toString();
  } catch {
    return href.split("#")[0];
  }
}

function sendVital(metric) {
  if (!APPPULSE_URL || !APPPULSE_KEY) return;

  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    url: sanitizeUrl(window.location.href),
    user_agent: navigator.userAgent,
  });

  // Use fetch with keepalive (survives page unloads like sendBeacon, but
  // avoids CORS credential issues that sendBeacon causes with wildcard origins).
  // credentials: "omit" is key - we don't need cookies, and it avoids the
  // "wildcard Access-Control-Allow-Origin + credentials" browser error.
  fetch(APPPULSE_URL + "/api/vitals?key=" + APPPULSE_KEY, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
    credentials: "omit",
  }).catch(() => {});
}

export function WebVitals() {
  useEffect(() => {
    onLCP(sendVital);
    onINP(sendVital);
    onCLS(sendVital);
    onFCP(sendVital);
    onTTFB(sendVital);
  }, []);
  return null;
}
